import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import * as uuid from 'uuid';
import { EventV2Document } from '@models/alerts-v2.model';
import { EntityLookupModel } from '@models/entity-lookup.model';
import { FlattenEventsWorkerModel } from '@models/flatten-events-worker.model';

@Injectable({
  providedIn: 'root',
})
export class FlattenEventsWorkerService {
  private worker: Worker | undefined;

  constructor() {
    if (typeof Worker !== 'undefined') {
      this.worker = new Worker(new URL('../../workers/flatten-events.worker', import.meta.url));
    }
  }

  runFlattenWorker(events: EventV2Document[], lookup: EntityLookupModel.EntityLookupMap): Observable<FlattenEventsWorkerModel.RunEventsFlattenSuccessMessage> {
    if (!this.worker) {
      return new Observable((subscriber) => {
        subscriber.error('Web Workers not supported in this environment.');
      });
    }

    return new Observable((subscriber) => {
      const requestId = uuid.v4();

      const handleMessage = (evt: MessageEvent<FlattenEventsWorkerModel.FlattenWorkerMessage>) => {
        const msg = evt?.data;

        if (FlattenEventsWorkerModel.isRunEventsFlattenSuccessMessage(msg) && msg.requestId === requestId) {
          subscriber.next(msg);
          subscriber.complete();
        } else if (FlattenEventsWorkerModel.isRunEventsFlattenFailMessage(msg) && msg.requestId === requestId) {
          subscriber.error(msg.error);
        }
      };

      this.worker.addEventListener('message', handleMessage);

      const message: FlattenEventsWorkerModel.RunEventsFlattenMessage = {
        type: 'RUN_EVENTS_FLATTEN',
        requestId,
        events,
        lookups: lookup,
      };

      this.worker.postMessage(message);

      // Cleanup listener on unsubscribe
      return () => {
        this.worker?.removeEventListener('message', handleMessage);
      };
    });
  }
}
